<template>
  <v-app >
    <v-main >
      <v-container class="d-flex flex-column" fluid style="min-height: 100vh; padding: 0px">
        <v-row style="background-color: white; padding: 0px; height: 100px; max-height: 100px; ">
    
          <v-col class="d-flex align-center" style="max-width: 30%; height: 100%;">
            <a class="text-decoration-none d-flex align-center" href="https://www.anf.es"
              style="background-color: red; height: 50%; margin-left: 50px;">
              <img :src="require('@/assets/anfac-logo-2024.png')" alt="ANF AC" style="height: 100%;" />
            </a>
          </v-col>
          <v-col class="d-flex flex-column justify-center position-relative"
            style="max-width: 40%; text-align: center; height: 100px;">
            <h3 style="text-align: center; margin-bottom: 0px; font-weight: bold;">{{ title }}</h3>
          </v-col>
          <v-col class="d-flex flex-column position-relative align-center" style="max-width: 30%; height: 100px;">
    
            <div style="
                position: absolute;
                right: 20px;
                top: 20px;          
              ">
    
              <v-menu transition="slide-y-transition">
                <template v-slot:activator="{ props }">
                  <v-btn style="
                      font-weight: bold;
                    " v-bind="props" append-icon="mdi-dots-vertical" color="primary" variant="text" size="small">
                    Descargar
                  </v-btn>
                </template>
                <v-list density="compact">
                  <v-list-item @click="downloadRootCAs" color="primary">
                    <template v-slot:prepend>
                      <v-icon size="small" icon="mdi-download"></v-icon>
                    </template>
                    <v-list-item-title>CAs Raíz</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="downloadIAs" color="primary">
                    <template v-slot:prepend>
                      <v-icon size="small" icon="mdi-download"></v-icon>
                    </template>
                    <v-list-item-title>CAs intermedias</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="downloadOCSPResponders" color="primary">
                    <template v-slot:prepend>
                      <v-icon size="small" icon="mdi-download"></v-icon>
                    </template>
                    <v-list-item-title>Certificados OCSP Responder</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="downloadCAInstaller" color="primary">
                    <template v-slot:prepend>
                      <v-icon size="small" icon="mdi-download"></v-icon>
                    </template>
                    <v-list-item-title>Instalador automático</v-list-item-title>
                  </v-list-item>
    
                  <v-list-item @click="downloadCertKit" color="primary">
                    <template v-slot:prepend>
                      <v-icon size="small" icon="mdi-download"></v-icon>
                    </template>
                    <v-list-item-title>KIT CERTIFICADOS TEST</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
            <div style="
                position: absolute;
                right: 10px;
                top: 50px;
                display: flex;
                justify-content: flex-end;
              ">
    
            </div>
          </v-col>
        </v-row>
        <router-view/>
        <v-row name="footer" class="footer" style="
            color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 10vh;
            padding: 0px;
            max-height: 15vh;
          ">
          <v-col>
            <p>
              Copyright © 2000 - {{ year }} ANF AC. Todos los derechos reservados. Technology
              powered by ANF AC
            </p>
            <p>
              <a :href="linkHref">{{ linkText }}</a>
              &nbsp;|&nbsp;
              <router-link :to="expiredLinkTo">{{ expiredLinkText }}</router-link>
            </p>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

.footer {
  background-color: #333333;
  padding: 0px;
}

a {
  background-color: transparent;
  text-decoration: none;
  color: #478ac9;
}
</style>

<script>
import config from "@/store/config";
export default {
  name: "AppView",
  data() {
    return {
      year: new Date().getFullYear(), // valor inicial por si falla
    };
  },
  
  computed: {
    linkHref() {
      return this.$route.path === "/historico" ? "/" : "/historico";
    },
    linkText() {
      return this.$route.path === "/historico"
        ? "Inicio"
        : "Histórico de CRLs / ARLs";
    },
    expiredLinkTo() {
      return this.$route.path === "/expired" ? "/" : "/expired";
    },
    expiredLinkText() {
      return this.$route.path === "/expired"
        ? "Ocultar CA expiradas"
        : "Mostrar CA expiradas";
    },
    title(){
      return this.$route.path === "/historico"?"ANF AC Histórico de CRLs / ARLs":"ANF AC Jerarquías y CRLs";
    }
  },
  mounted() {
    // Intentar obtener la fecha desde el header "Date"
    fetch("/", { method: "HEAD" })
      .then((res) => {
        const dateHeader = res.headers.get("date");
        if (dateHeader) {
          this.year = new Date(dateHeader).getFullYear();
        }
      })
      .catch(() => {
        // fallback ya es el año del cliente
      });
  },
  methods: {
    downloadCAInstaller() {
      // Construct the URL to the executable file
      const fileUrl = `/InstaladorJerarquias.exe`;

      // Create a temporary anchor element
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = "InstaladorJerarquias.exe";

      // Append the anchor element to the document body and trigger the download
      document.body.appendChild(link);
      link.click();

      // Cleanup: remove the anchor element after download
      document.body.removeChild(link);
    },
    downloadOCSPResponders() {
      // Construct the URL to the executable file
      const fileUrl = config.baseUrl + `/download/ocsp`;

      // Create a temporary anchor element
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = "ANF AC - Respondedores OCSP.zip";

      // Append the anchor element to the document body and trigger the download
      document.body.appendChild(link);
      link.click();

      // Cleanup: remove the anchor element after download
      document.body.removeChild(link);
    },
    downloadIAs() {
      // Construct the URL to the executable file
      const fileUrl = config.baseUrl + `/download/ias`;

      // Create a temporary anchor element
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = "ANF AC - CAs intermedias.zip";

      // Append the anchor element to the document body and trigger the download
      document.body.appendChild(link);
      link.click();

      // Cleanup: remove the anchor element after download
      document.body.removeChild(link);
    },
    downloadRootCAs() {
      // Construct the URL to the executable file
      const fileUrl = config.baseUrl + `/download/roots`;

      // Create a temporary anchor element
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = "ANF AC - CAs Raíz.zip";

      // Append the anchor element to the document body and trigger the download
      document.body.appendChild(link);
      link.click();

      // Cleanup: remove the anchor element after download
      document.body.removeChild(link);
    },
    downloadCertKit() {
      // Construct the URL to the executable file
      const newTab = window.open(config.baseUrl + '/download/kit', '_blank');

      // Check if the new tab is successfully opened
      if (newTab) {
        // You can optionally add some code here to handle the flow or timeout
        // in case the user closes the tab without downloading the file
      } else {
        alert("Please enable pop-ups in your browser to proceed with the download.");
      }
    }
  }
}
</script>
